import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { createCustomerAddress } from '../customers'

export default function useCustomerAddressCreate() {
  const queryClient = useQueryClient()

  const { mutate, isLoading } = useMutation(createCustomerAddress, {
    onSuccess: () => {
      queryClient.invalidateQueries('customerAddresses')
      notification.success({
        message: 'Sucesso!',
        description: 'Cadastro realizado com sucesso!'
      })
    },
    onError: () => {
      notification.error({
        message: 'Erro',
        description: 'Não foi possível completar o cadastro!'
      })
    }
  })

  return { mutate, isLoading }
}
